export default __webpack_public_path__ + "static/media/smile.6d8040be.gif";